import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  cardWrapper: {
    '&&': {
      border: `1px solid ${theme.palette.custom.grey}`,
      borderRadius: '10px',
      boxShadow: 'none',

      [theme.breakpoints.down('tablet')]: {
        width: 'calc(100vw - 40px)',
        height: '100%',
        minHeight: 70,
      },
      [theme.breakpoints.up('tablet')]: {
        width: 178,
        height: 'auto',
        minHeight: 178,
      },
    },
  },
  cardActionArea: {
    '&&': {
      [theme.breakpoints.down('tablet')]: {
        display: 'flex',
        justifyContent: 'flex-start',
        gap: SPACES.xs,
      },

      maxWidth: '100%',
      height: 'inherit',
    },
  },
  cardImageWrapper: {
    '&&': {
      height: 'inherit',
      position: 'relative',
    },
  },
  cardImage: {
    '&&': {
      [theme.breakpoints.down('tablet')]: {
        width: 70,
        height: 'inherit',
        aspectRatio: '1/1',
      },
      [theme.breakpoints.up('tablet')]: {
        height: 130,
        width: 178,
      },
    },
  },
  cardImageSubIcon: {
    '&&': {
      position: 'absolute',
      bottom: '5%',
      right: '5%',
    },
  },

  imageButton: {
    '&&': {
      position: 'absolute',
      top: '3px',
      right: '3px',
      color: theme.palette.custom.white,
      padding: SPACES.xxxs,
      zIndex: 1000,

      [theme.breakpoints.down('tablet')]: {
        display: 'none',
      },
    },
  },

  statusIcon: {
    '&&': {
      position: 'absolute',
      top: '3px',
      left: '3px',
      color: theme.palette.custom.white,
      padding: SPACES.xxxs,
      zIndex: 1000,

      [theme.breakpoints.down('tablet')]: {
        display: 'none',
      },
    },
  },
  cardContent: {
    '&&': {
      color: theme.palette.custom.darkBlue2,

      whiteSpace: 'normal',
      wordBreak: 'break-word',

      [theme.breakpoints.down('tablet')]: {
        padding: 0,
      },
      [theme.breakpoints.up('tablet')]: {
        padding: `${SPACES.xxxs} ${SPACES.xs} ${SPACES.xs}`,
      },
    },
  },
  cardName: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: FONTS.SIZES.m,
      lineHeight: 1.35,
      color: 'inherit',
    },
  },
  cardCode: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.light,
      fontSize: FONTS.SIZES.xs,
      lineHeight: 1.4,
      color: 'inherit',

      textTransform: 'uppercase',
    },
  },
  cardDescription: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: FONTS.SIZES.xs,
      lineHeight: 1.4,

      '&:first-letter': {
        textTransform: 'uppercase',
      },

      "&[data-status='active']": {
        color: theme.palette.custom.primary,
      },
      "&[data-status='pending']": {
        color: theme.palette.custom.suppressing,
      },
      "&[data-status='deactivated']": {
        color: theme.palette.custom.grey2,
      },
    },
  },
  moreButton: {
    '&&': {
      marginLeft: 'auto',

      color: theme.palette.custom.darkBlue2,

      [theme.breakpoints.up('tablet')]: {
        display: 'none',
      },
    },
  },
}))

export default useStyles
